import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as Colors from 'ui-library/Colors';

export enum ValidationState {
  VALID = 'valid',
  INVALID = 'invalid',
  NONE = 'none',
}

export interface ValidationDotProps {
  validationState: ValidationState;
}

/**
 * Visual indicator of a tri-state status: green for valid, red for invalid, gray for none.
 */
export default function ValidationDot(props: ValidationDotProps): JSX.Element {
  switch (props.validationState) {
    case 'valid':
      return <div className={css(styles.dot, styles.validDot)} />;
    case 'invalid':
      return <div className={css(styles.dot, styles.invalidDot)} />;
    default:
      return <div className={css(styles.dot)} />;
  }
}

const styles = StyleSheet.create({
  dot: {
    height: 10,
    width: 10,
    borderRadius: '50%',
    display: 'inline-block',
    backgroundColor: Colors.GRAY_LIGHT,
  },
  validDot: {
    backgroundColor: Colors.GREEN,
  },
  invalidDot: {
    backgroundColor: Colors.RED_LIGHT,
  },
});
